import { c as compute_rest_props, s as subscribe, n as noop, f as set_store_value } from "../../../../../chunks/utils.js";
import { c as create_ssr_component, g as getContext, s as spread, a as escape_attribute_value, b as escape_object, d as add_attribute, e as escape, v as validate_component, i as each, h as setContext } from "../../../../../chunks/ssr.js";
import { p as page } from "../../../../../chunks/stores.js";
import { E as EmployeeAvatar } from "../../../../../chunks/EmployeeAvatar.js";
import { C as ClipboardSolid, F as FolderSolid, M as MessagesSolid, I as InfoCircleOutline, E as EmploymentStatus } from "../../../../../chunks/EmploymentStatus.js";
import { E as EditSolid, T as TicketOutline, a as TabButton } from "../../../../../chunks/TabButton.js";
import { w as writable } from "../../../../../chunks/index2.js";
import { B as Button } from "../../../../../chunks/Button.js";
import { M as Modal } from "../../../../../chunks/Modal2.js";
import { T as Tooltip } from "../../../../../chunks/Tooltip.js";
import { twMerge } from "tailwind-merge";
import { B as BuildingSolid } from "../../../../../chunks/BuildingSolid.js";
import { a as CheckCircleSolid } from "../../../../../chunks/CardLayoutSubmitButton.js";
import { C as CloseCircleSolid } from "../../../../../chunks/CloseCircleSolid.js";
import { E as EnvelopeSolid } from "../../../../../chunks/EnvelopeSolid.js";
import { G as GridOutline } from "../../../../../chunks/GridOutline.js";
import { L as ListOutline } from "../../../../../chunks/ListOutline.js";
import { P as PenOutline } from "../../../../../chunks/PenOutline.js";
import { U as UserSolid } from "../../../../../chunks/UserSolid.js";
import { S as Select } from "../../../../../chunks/Select.js";
import "../../../../../chunks/api.js";
import dayjs from "dayjs";
import "../../../../../chunks/qualification.js";
import { M as ModalFooter, B as BuildingOutline, a as ModalHeader } from "../../../../../chunks/ModalHeader.js";
import "../../../../../chunks/client.js";
import { t as templateDocuments } from "../../../../../chunks/generateContractPreview.js";
import "../../../../../chunks/modal.js";
import { t as tariffs } from "../../../../../chunks/tariffs.js";
import "@tiptap/extension-link";
import "../../../../../chunks/TipTapEditor.js";
import { m as mailTemplates, N as NewContractForm, E as EmailTemplateEditor, R as ReentryModal } from "../../../../../chunks/ReentryModal.js";
import { a as allUnits } from "../../../../../chunks/unit.js";
import { E as EmployeeInfo, Q as Qualifications, T as TaxAndInsurance, B as BankAccount } from "../../../../../chunks/TaxAndInsurance.js";
import { L as Label } from "../../../../../chunks/Label.js";
import { I as Input } from "../../../../../chunks/Input.js";
import { T as Typeahead } from "../../../../../chunks/Typeahead.js";
import { g as globalToast } from "../../../../../chunks/toast2.js";
import { a as asValue } from "../../../../../chunks/lenkradDate.js";
import { f as formatCurrency } from "../../../../../chunks/currency.js";
import { c as contractTypes } from "../../../../../chunks/contractTypes.js";
import { d as PUBLIC_MAIL_FROM_EMAIL, e as PUBLIC_MAIL_FROM_NAME } from "../../../../../chunks/public.js";
import { T as Textarea } from "../../../../../chunks/Textarea.js";
import { S as StatusTriggerButtons } from "../../../../../chunks/StatusTriggerButtons.js";
import { G as GlobalShortcuts } from "../../../../../chunks/GlobalShortcuts.js";
import { l as listView } from "../../../../../chunks/viewStore.js";
const BellSolid = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "bell solid" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path d="M17.133 12.632v-1.8a5.406 5.406 0 0 0-4.154-5.262.955.955 0 0 0 .021-.106V3.1a1 1 0 0 0-2 0v2.364a.955.955 0 0 0 .021.106 5.406 5.406 0 0 0-4.154 5.262v1.8C6.867 15.018 5 15.614 5 16.807 5 17.4 5 18 5.538 18h12.924C19 18 19 17.4 19 16.807c0-1.193-1.867-1.789-1.867-4.175ZM8.823 19a3.453 3.453 0 0 0 6.354 0H8.823Z"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path d="M17.133 12.632v-1.8a5.406 5.406 0 0 0-4.154-5.262.955.955 0 0 0 .021-.106V3.1a1 1 0 0 0-2 0v2.364a.955.955 0 0 0 .021.106 5.406 5.406 0 0 0-4.154 5.262v1.8C6.867 15.018 5 15.614 5 16.807 5 17.4 5 18 5.538 18h12.924C19 18 19 17.4 19 16.807c0-1.193-1.867-1.789-1.867-4.175ZM8.823 19a3.453 3.453 0 0 0 6.354 0H8.823Z"></path></svg>`} `;
});
function parseHandlebars(template, data) {
  let html = template.content;
  html = html.replace(`{{currentYear}}`, dayjs().format("YYYY"));
  template.placeholders.forEach((placeholder) => {
    let fillIn = placeholder.templateProperty;
    try {
      console.log({
        entity: placeholder.entity,
        found: data[placeholder.entity],
        property: placeholder.entityProperty,
        target: placeholder.templateProperty,
        fillIn
      });
      fillIn = data[placeholder.entity][placeholder.entityProperty];
      let matcher;
      if (typeof fillIn !== "undefined" && placeholder.formatter) {
        switch (placeholder.formatter) {
          case "currency":
            fillIn = formatCurrency(fillIn, "EUR");
            break;
          case "date":
            if (!asValue(fillIn)) {
              fillIn = "unbefristet";
            } else {
              fillIn = dayjs(asValue(fillIn)).format("DD.MM.YYYY");
            }
            break;
          case "time":
            fillIn = dayjs(asValue(fillIn)).format("HH:mm");
            break;
          case "matcher":
            matcher = JSON.parse(placeholder.matcher);
            fillIn = matcher[fillIn] || fillIn;
            break;
          case "link":
            matcher = JSON.parse(placeholder.matcher);
            fillIn = matcher.link.replace(/{{(.*?)}}/g, fillIn);
            break;
        }
      }
    } catch (e) {
      console.log("error", e);
    }
    if (placeholder.entity === "Input" && typeof data[placeholder.entity][placeholder.templateProperty] !== "undefined") {
      if (placeholder.entityProperty === "date") {
        fillIn = dayjs(asValue(data[placeholder.entity][placeholder.templateProperty])).format("DD.MM.YYYY");
      } else if (placeholder.entityProperty === "matcher") {
        const matcher = JSON.parse(placeholder.matcher);
        fillIn = data[placeholder.entity][placeholder.templateProperty];
        fillIn = matcher[fillIn] || fillIn;
      } else {
        fillIn = data[placeholder.entity][placeholder.templateProperty];
      }
    }
    if (typeof fillIn !== "undefined") {
      html = html.replace(`{{${placeholder.templateProperty}}}`, fillIn);
      const regEx = new RegExp("{{var:" + placeholder.templateProperty + "(:[^}]+)*}}", "g");
      html = html.replace(regEx, fillIn);
    }
  });
  return html;
}
const NewContractModal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $mailTemplates, $$unsubscribe_mailTemplates;
  let $$unsubscribe_templateDocuments;
  let $$unsubscribe_allUnits;
  let $$unsubscribe_tariffs;
  let $formStatus, $$unsubscribe_formStatus = noop, $$subscribe_formStatus = () => ($$unsubscribe_formStatus(), $$unsubscribe_formStatus = subscribe(formStatus, ($$value) => $formStatus = $$value), formStatus);
  let $$unsubscribe_doneModal;
  $$unsubscribe_mailTemplates = subscribe(mailTemplates, (value) => $mailTemplates = value);
  $$unsubscribe_templateDocuments = subscribe(templateDocuments, (value) => value);
  $$unsubscribe_allUnits = subscribe(allUnits, (value) => value);
  $$unsubscribe_tariffs = subscribe(tariffs, (value) => value);
  let { open = false } = $$props;
  let { employee } = $$props;
  let { contract = {
    currentHistory: {
      startDate: dayjs().add(1, "month").date(1).format("YYYY-MM-DD"),
      endDate: dayjs().year() + "-12-31",
      hiredAs: "ServicehilfKraft"
    },
    history: void 0
  } } = $$props;
  let formStatus = writable({
    loading: false,
    preview: null,
    formComplete: false,
    triggerPreview: false,
    triggerContract: false
  });
  $$subscribe_formStatus();
  let doneModal = getContext("doneModal");
  $$unsubscribe_doneModal = subscribe(doneModal, (value) => value);
  let mailTemplate;
  if ($$props.open === void 0 && $$bindings.open && open !== void 0) $$bindings.open(open);
  if ($$props.employee === void 0 && $$bindings.employee && employee !== void 0) $$bindings.employee(employee);
  if ($$props.contract === void 0 && $$bindings.contract && contract !== void 0) $$bindings.contract(contract);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Modal, "Modal").$$render(
      $$result,
      { size: "xl", open },
      {
        open: ($$value) => {
          open = $$value;
          $$settled = false;
        }
      },
      {
        footer: () => {
          return `${validate_component(ModalFooter, "ModalFooter").$$render(
            $$result,
            {
              disabled: $formStatus.loading,
              showEdit: !!$formStatus.preview
            },
            {},
            {
              right: () => {
                return `${$formStatus.preview ? `${validate_component(Button, "Button").$$render(
                  $$result,
                  {
                    disabled: $formStatus.loading,
                    class: "!text-decoration-none whitespace-nowrap",
                    download: "Vertragsangebot_" + employee.name.replaceAll(" ", "_") + ".docx",
                    href: URL.createObjectURL($formStatus.preview),
                    target: "_blank",
                    color: "light"
                  },
                  {},
                  {
                    default: () => {
                      return `Vorschau erzeugter Vertrag`;
                    }
                  }
                )} ${contract.history ? `${validate_component(Button, "Button").$$render(
                  $$result,
                  {
                    disabled: $formStatus.loading,
                    class: "bg-sky-100 text-neutral-600 whitespace-nowrap"
                  },
                  {},
                  {
                    default: () => {
                      return `Email versenden`;
                    }
                  }
                )}` : `${validate_component(Button, "Button").$$render(
                  $$result,
                  {
                    class: "bg-sky-100 text-neutral-600 whitespace-nowrap",
                    disabled: $formStatus.loading
                  },
                  {},
                  {
                    default: () => {
                      return `Vertrag erstellen`;
                    }
                  }
                )}`}` : `${$formStatus.formComplete ? `${validate_component(Button, "Button").$$render(
                  $$result,
                  {
                    disabled: $formStatus.loading,
                    class: "bg-sky-100 text-neutral-600 whitespace-nowrap"
                  },
                  {},
                  {
                    default: () => {
                      return `Vertragsvorschau erzeugen`;
                    }
                  }
                )}` : ``}`}`;
              }
            }
          )} `;
        },
        header: () => {
          return `<h3 class="text-xl font-semibold text-neutral-600 dark:text-white pl-4 flex items-center">${validate_component(BuildingOutline, "BuildingOutline").$$render($$result, { class: "mr-2 w-4" }, {}, {})}
            Neuer Vertrag: ${escape(employee.firstName)} ${escape(employee.lastName)}</h3> `;
        },
        default: () => {
          return `<div class="mt-3 space-y-3">${validate_component(EmployeeInfo, "EmployeeInfo").$$render($$result, { display: false, readOnly: true }, {}, {})} ${validate_component(Qualifications, "Qualifications").$$render($$result, { display: false, readOnly: true }, {}, {})} ${validate_component(TaxAndInsurance, "TaxAndInsurance").$$render($$result, { display: false, readOnly: true }, {}, {})} ${validate_component(BankAccount, "BankAccount").$$render($$result, { display: false, readOnly: true }, {}, {})}</div> <div class="w-full">${contract.history ? `<div class="space-y-2 mb-3"><span data-svelte-h="svelte-1ctq8t4">Email Template</span> ${validate_component(Select, "Select").$$render(
            $$result,
            {
              required: true,
              items: $mailTemplates.filter((x) => x.level === "contractible").map((x) => ({ ...x, value: x.id })),
              value: mailTemplate.id
            },
            {
              value: ($$value) => {
                mailTemplate.id = $$value;
                $$settled = false;
              }
            },
            {}
          )}</div> ${``}` : `${validate_component(NewContractForm, "NewContractForm").$$render(
            $$result,
            {
              employee,
              sharedState: formStatus,
              contract
            },
            {
              sharedState: ($$value) => {
                formStatus = $$value;
                $$settled = false;
              },
              contract: ($$value) => {
                contract = $$value;
                $$settled = false;
              }
            },
            {}
          )}`}</div>`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_mailTemplates();
  $$unsubscribe_templateDocuments();
  $$unsubscribe_allUnits();
  $$unsubscribe_tariffs();
  $$unsubscribe_formStatus();
  $$unsubscribe_doneModal();
  return $$rendered;
});
const EmployeeEmailModal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_mailTemplates;
  let $allUnits, $$unsubscribe_allUnits;
  let $$unsubscribe_globalToast;
  $$unsubscribe_mailTemplates = subscribe(mailTemplates, (value) => value);
  $$unsubscribe_allUnits = subscribe(allUnits, (value) => $allUnits = value);
  $$unsubscribe_globalToast = subscribe(globalToast, (value) => value);
  let { open = false } = $$props;
  let { employee } = $$props;
  let input = {};
  let contractHistory = null;
  let email = {
    from: {
      fromEmail: PUBLIC_MAIL_FROM_EMAIL,
      fromName: PUBLIC_MAIL_FROM_NAME
    },
    subject: "",
    template: null,
    variables: []
  };
  let filteredTemplates = [];
  const definedFroms = [
    {
      name: "Legal: " + PUBLIC_MAIL_FROM_EMAIL,
      value: {
        fromEmail: PUBLIC_MAIL_FROM_EMAIL,
        fromName: PUBLIC_MAIL_FROM_NAME
      }
    }
  ];
  const changeEmailTemplate = (template) => {
    email.template = null;
    if (template.subject && template?.subject.length > 0) {
      email.subject = parseHandlebars({ ...template, content: template?.subject }, {
        Employee: employee,
        Contract: contractHistory,
        Input: input,
        Unit: $allUnits.find((x) => x.id === employee.unitId)
      });
    } else {
      email.subject = "";
    }
    setTimeout(
      () => {
        email.template = template;
      },
      400
    );
  };
  if ($$props.open === void 0 && $$bindings.open && open !== void 0) $$bindings.open(open);
  if ($$props.employee === void 0 && $$bindings.employee && employee !== void 0) $$bindings.employee(employee);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        size: "xl",
        title: "E-Mail an " + employee.name + " verfassen",
        open
      },
      {
        open: ($$value) => {
          open = $$value;
          $$settled = false;
        }
      },
      {
        footer: () => {
          return `${validate_component(ModalFooter, "ModalFooter").$$render($$result, { nextText: "Senden" }, {}, {})} `;
        },
        header: () => {
          return `${validate_component(ModalHeader, "ModalHeader").$$render(
            $$result,
            {
              title: "E-Mail an " + employee.name + " verfassen"
            },
            {},
            {}
          )}`;
        },
        default: () => {
          return `<form><div class="grid grid-cols-2 w-full gap-4">${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-1a7uxj">Von</span> ${validate_component(Select, "Select").$$render(
                $$result,
                {
                  items: definedFroms,
                  required: true,
                  value: email.from
                },
                {
                  value: ($$value) => {
                    email.from = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-18qmyvl">An</span> <div class="pt-2">${escape(employee?.email)}</div>`;
            }
          })}</div> <div class="mt-3">${validate_component(Typeahead, "Typeahead").$$render(
            $$result,
            {
              label: "Vorlage",
              value: email?.template?.name,
              data: filteredTemplates,
              extract: changeEmailTemplate
            },
            {},
            {}
          )}</div> ${email.template ? `${email.template?.placeholders.find((x) => x.entity === "Contract") ? `<div class="mt-3">${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-b4gjn5">Vertragshistorie</span> ${validate_component(Select, "Select").$$render(
                $$result,
                {
                  items: employee.contracts.map((x) => x.history).flat().map((x) => ({
                    value: x,
                    name: x.startDate.value.match(/\d{4}-\d{2}-\d{2}/)[0] + " - " + (x.endDate.value ? x.endDate.value.match(/\d{4}-\d{2}-\d{2}/)[0] : "unbefristet") + " - " + (contractTypes.find((y) => y.value === x.historyType)?.name || "Basisvertrag")
                  })),
                  required: true,
                  value: contractHistory
                },
                {
                  value: ($$value) => {
                    contractHistory = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })}</div>` : ``} ${each(email.template?.placeholders, (placeholder) => {
            return `${placeholder.entity === "Input" ? `<div class="mt-3">${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
              default: () => {
                return `<span>${escape(placeholder.templateProperty)}</span> ${validate_component(Input, "Input").$$render(
                  $$result,
                  {
                    required: true,
                    type: placeholder.entityProperty,
                    value: input[placeholder.templateProperty]
                  },
                  {
                    value: ($$value) => {
                      input[placeholder.templateProperty] = $$value;
                      $$settled = false;
                    }
                  },
                  {}
                )} `;
              }
            })} </div>` : ``}`;
          })}` : ``} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 my-3" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-1cpjvx0">Betreff</span> ${validate_component(Input, "Input").$$render(
                $$result,
                {
                  required: true,
                  type: "text",
                  value: email.subject
                },
                {
                  value: ($$value) => {
                    email.subject = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })} <div class="flex justify-between min-h-[500px]"><div class="w-4/5">${email.template ? `${validate_component(EmailTemplateEditor, "EmailTemplateEditor").$$render(
            $$result,
            {
              preview: true,
              template: email.template,
              fillData: {
                Employee: employee,
                Contract: contractHistory,
                Input: input,
                Unit: $allUnits.find((x) => x.id === employee.unitId)
              }
            },
            {},
            {}
          )} ` : ``}</div> <div>${validate_component(Button, "Button").$$render($$result, { color: "alternative", size: "xs" }, {}, {
            default: () => {
              return `Anhang hinzufügen`;
            }
          })} ${each(email.variables, (variable) => {
            return `${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 my-3" }, {}, {
              default: () => {
                return `<span>${escape(variable.variable)}</span> ${validate_component(Input, "Input").$$render(
                  $$result,
                  {
                    required: true,
                    type: "text",
                    value: variable.value
                  },
                  {
                    value: ($$value) => {
                      variable.value = $$value;
                      $$settled = false;
                    }
                  },
                  {}
                )} `;
              }
            })}`;
          })}</div></div></form>`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_mailTemplates();
  $$unsubscribe_allUnits();
  $$unsubscribe_globalToast();
  return $$rendered;
});
const EmployeeReminderModal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { employee } = $$props;
  let { open = false } = $$props;
  let reminder = {
    employeeUuid: employee.uuid,
    remindAt: /* @__PURE__ */ new Date(),
    note: ""
  };
  if ($$props.employee === void 0 && $$bindings.employee && employee !== void 0) $$bindings.employee(employee);
  if ($$props.open === void 0 && $$bindings.open && open !== void 0) $$bindings.open(open);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Modal, "Modal").$$render(
      $$result,
      { title: "Reminder erstellen", open },
      {
        open: ($$value) => {
          open = $$value;
          $$settled = false;
        }
      },
      {
        footer: () => {
          return `${validate_component(ModalFooter, "ModalFooter").$$render($$result, { nextText: "Reminder anlegen" }, {}, {})} `;
        },
        header: () => {
          return `${validate_component(ModalHeader, "ModalHeader").$$render($$result, { title: "Reminder erstellen" }, {}, {})} `;
        },
        default: () => {
          return `<form><div class="grid grid-cols-5 w-full gap-4">${validate_component(Label, "Label").$$render(
            $$result,
            {
              for: "reminderText",
              class: "flex justify-end items-center"
            },
            {},
            {
              default: () => {
                return `Erinnerung`;
              }
            }
          )} ${validate_component(Textarea, "Textarea").$$render(
            $$result,
            {
              required: true,
              id: "reminderText",
              name: "reminderText",
              class: "col-span-4",
              type: "text",
              value: reminder.note
            },
            {
              value: ($$value) => {
                reminder.note = $$value;
                $$settled = false;
              }
            },
            {}
          )} ${validate_component(Label, "Label").$$render(
            $$result,
            {
              for: "reminderDate",
              class: "flex justify-end items-center"
            },
            {},
            {
              default: () => {
                return `Wecker`;
              }
            }
          )} ${validate_component(Input, "Input").$$render(
            $$result,
            {
              required: true,
              id: "reminderDate",
              name: "reminderDate",
              class: "col-span-4",
              type: "datetime-local",
              value: reminder.remindAt
            },
            {
              value: ($$value) => {
                reminder.remindAt = $$value;
                $$settled = false;
              }
            },
            {}
          )}</div></form>`;
        }
      }
    )}`;
  } while (!$$settled);
  return $$rendered;
});
const Layout = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let unit_name;
  let $super_edit, $$unsubscribe_super_edit;
  let $$unsubscribe_trigger_submits;
  let $employee, $$unsubscribe_employee;
  let $page, $$unsubscribe_page;
  let $$unsubscribe_employee_extra;
  let $listView, $$unsubscribe_listView;
  let $doneModal, $$unsubscribe_doneModal;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  $$unsubscribe_listView = subscribe(listView, (value) => $listView = value);
  let employee = writable($page.data.employee);
  $$unsubscribe_employee = subscribe(employee, (value) => $employee = value);
  setContext("employee", employee);
  let reentryModal = false;
  let doneModal = writable(false);
  $$unsubscribe_doneModal = subscribe(doneModal, (value) => $doneModal = value);
  setContext("doneModal", doneModal);
  const employee_extra = writable({
    tax_brackets: [],
    health_insurances: [],
    religious_denoms: [],
    iban_info: null,
    nationalities: [],
    graduations: []
  });
  $$unsubscribe_employee_extra = subscribe(employee_extra, (value) => value);
  setContext("employee_extra", employee_extra);
  const super_edit = writable(false);
  $$unsubscribe_super_edit = subscribe(super_edit, (value) => $super_edit = value);
  setContext("super_edit", super_edit);
  let trigger_submits = writable(/* @__PURE__ */ new Set());
  $$unsubscribe_trigger_submits = subscribe(trigger_submits, (value) => value);
  setContext("trigger_submits", trigger_submits);
  let reminderModal = false;
  let emailModal = false;
  let contractModal = false;
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    set_store_value(employee, $employee = $page.data.employee, $employee);
    unit_name = $page.data.units.find((unit) => unit.id === $employee.unitId)?.shortCode;
    $$rendered = `${validate_component(GlobalShortcuts, "GlobalShortcuts").$$render($$result, {}, {}, {})} <div class="flex flex-col md:flex-row items-start gap-3 px-4 pt-7"><div class="flex flex-1 flex-row items-center gap-3">${validate_component(EmployeeAvatar, "EmployeeAvatar").$$render(
      $$result,
      {
        editable: $super_edit,
        employee: $employee,
        size: "2xl"
      },
      {},
      {}
    )} <div class="flex flex-col items-start gap-1"><h1 class="text-base text-neutral-600 sm:text-lg md:text-2xl font-bold">${escape($employee.name)}</h1> <span class="text-neutral-600">Unit: ${escape(unit_name)}</span> <div class="text-neutral-600 text-[14px] flex gap-2">${validate_component(TicketOutline, "TicketOutline").$$render($$result, { class: "text-primary-400 " }, {}, {})} <span>${escape($employee.employeeNumber || "Bewerber")}</span></div></div></div> <div class="flex gap-3 mb-2">${!$super_edit ? `${validate_component(Button, "Button").$$render(
      $$result,
      {
        class: "bg-secondary-700 hover:bg-secondary-700",
        size: "xs"
      },
      {},
      {
        default: () => {
          return `${validate_component(BellSolid, "BellSolid").$$render($$result, { class: "w-4 mr-2" }, {}, {})} <span data-svelte-h="svelte-1nxq8fk">Reminder erstellen</span>`;
        }
      }
    )} ${validate_component(Button, "Button").$$render(
      $$result,
      {
        class: "bg-secondary-700 hover:bg-secondary-700",
        size: "xs"
      },
      {},
      {
        default: () => {
          return `${validate_component(EnvelopeSolid, "EnvelopeSolid").$$render($$result, { class: "w-4 mr-2" }, {}, {})} <span data-svelte-h="svelte-17iuboa">E-Mail verfassen</span>`;
        }
      }
    )}` : ``} ${$super_edit ? `${validate_component(Button, "Button").$$render($$result, { size: "xs", class: "bg-red-400" }, {}, {
      default: () => {
        return `${validate_component(CloseCircleSolid, "CloseCircleSolid").$$render($$result, { class: "w-4 mr-2" }, {}, {})}
                Abbrechen`;
      }
    })} ${validate_component(Button, "Button").$$render($$result, { size: "xs" }, {}, {
      default: () => {
        return `${validate_component(CheckCircleSolid, "CheckCircleSolid").$$render($$result, { class: "w-4 mr-2" }, {}, {})}
                Speichern`;
      }
    })}` : `${$page.url.pathname.match(/\/employee\/[a-f0-9-]+$/i) ? `${validate_component(Button, "Button").$$render($$result, { size: "xs", icon: EditSolid }, {}, {
      default: () => {
        return `${validate_component(PenOutline, "PenOutline").$$render($$result, { class: "w-4 mr-2" }, {}, {})} <span data-svelte-h="svelte-h2bn3b">Bearbeiten</span>`;
      }
    })}` : ``} ${(!$employee.currentContract || dayjs(asValue($employee.currentContract.completeTimeframe.endDate)).isAfter(dayjs().subtract(30, "days"))) && ($employee.employmentStatus === "active" || $employee.employmentStatus === "training-verified" || $employee.employmentStatus === "inactive" || $employee.employmentStatus === "data-re-provided") ? `${validate_component(Button, "Button").$$render(
      $$result,
      {
        class: "bg-sky-100 text-neutral-600",
        size: "xs"
      },
      {},
      {
        default: () => {
          return `${validate_component(BuildingSolid, "BuildingSolid").$$render($$result, { class: "w-4 mr-2" }, {}, {})} ${$employee.contracts.length > 0 ? `<span data-svelte-h="svelte-1fdnfyq">Wiedereinstieg</span>` : `<span data-svelte-h="svelte-h2cqry">Vertragsangebot erstellen</span>`}`;
        }
      }
    )}` : `${!$employee.currentContract || $employee.employmentStatus === "rebuddy" ? `${validate_component(StatusTriggerButtons, "StatusTriggerButtons").$$render(
      $$result,
      { employee: $employee },
      {
        employee: ($$value) => {
          $employee = $$value;
          $$settled = false;
        }
      },
      {}
    )}` : ``}`}`}</div></div> <div class="flex flex-row items-end justify-between w-full md:border-b border-gray-300 mt-5"><div class="flex flex-wrap md:flex-nowrap flex-row justify-start items-center gap-3 md:gap-0">${validate_component(TabButton, "TabButton").$$render(
      $$result,
      {
        href: "/employee/" + $page.params.uuid,
        icon: UserSolid,
        title: "Stammdaten"
      },
      {},
      {}
    )} ${validate_component(TabButton, "TabButton").$$render(
      $$result,
      {
        href: "/employee/" + $page.params.uuid + "/vertrag",
        icon: ClipboardSolid,
        title: "Vertrag / Gehalt"
      },
      {},
      {}
    )} ${validate_component(TabButton, "TabButton").$$render(
      $$result,
      {
        href: "/employee/" + $page.params.uuid + "/dokumente",
        icon: FolderSolid,
        title: "Dokumente"
      },
      {},
      {}
    )} ${$employee.userId ? `${validate_component(TabButton, "TabButton").$$render(
      $$result,
      {
        href: "/employee/" + $page.params.uuid + "/connect",
        icon: MessagesSolid,
        title: "Connect"
      },
      {},
      {}
    )}` : ``}</div> <div class="max-w-sm w-full pl-[1.1rem] flex justify-between"><div class="h-[50px] flex gap-1 items-center"><div class="text-neutral-600 dark:text-gray-400 whitespace-nowrap relative">${validate_component(InfoCircleOutline, "InfoCircleOutline").$$render($$result, { class: "text-primary-400" }, {}, {})}</div> <div>${validate_component(EmploymentStatus, "EmploymentStatus").$$render(
      $$result,
      {
        editable: $super_edit,
        size: "sm",
        uuid: $employee.uuid,
        status: $employee.employmentStatus
      },
      {
        status: ($$value) => {
          $employee.employmentStatus = $$value;
          $$settled = false;
        }
      },
      {}
    )}</div></div> <div class="pr-3 pt-1">${validate_component(Button, "Button").$$render(
      $$result,
      {
        color: "alternative",
        pill: true,
        class: "!p-2"
      },
      {},
      {
        default: () => {
          return `${$listView ? `${validate_component(ListOutline, "ListOutline").$$render($$result, { class: "text-primary-600" }, {}, {})}` : `${validate_component(GridOutline, "GridOutline").$$render($$result, { class: "text-primary-600" }, {}, {})}`}`;
        }
      }
    )} ${validate_component(Tooltip, "Tooltip").$$render($$result, {}, {}, {
      default: () => {
        return `Ansicht wechseln`;
      }
    })}</div></div></div> ${$employee.contracts.length > 0 ? `${validate_component(ReentryModal, "ReentryModal").$$render(
      $$result,
      {
        contract: $employee.currentContract,
        employee: $employee,
        open: reentryModal
      },
      {
        open: ($$value) => {
          reentryModal = $$value;
          $$settled = false;
        }
      },
      {}
    )}` : ``} ${validate_component(EmployeeEmailModal, "EmployeeEmailModal").$$render(
      $$result,
      { open: emailModal, employee: $employee },
      {
        open: ($$value) => {
          emailModal = $$value;
          $$settled = false;
        },
        employee: ($$value) => {
          $employee = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(NewContractModal, "NewContractModal").$$render(
      $$result,
      { open: contractModal, employee: $employee },
      {
        open: ($$value) => {
          contractModal = $$value;
          $$settled = false;
        },
        employee: ($$value) => {
          $employee = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(EmployeeReminderModal, "EmployeeReminderModal").$$render(
      $$result,
      { open: reminderModal, employee: $employee },
      {
        open: ($$value) => {
          reminderModal = $$value;
          $$settled = false;
        },
        employee: ($$value) => {
          $employee = $$value;
          $$settled = false;
        }
      },
      {}
    )} <div class="pt-12 px-0">${slots.default ? slots.default({}) : ``}</div> ${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        size: "xs",
        autoclose: true,
        open: $doneModal
      },
      {
        open: ($$value) => {
          $doneModal = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `<div class="text-center">${validate_component(CheckCircleSolid, "CheckCircleSolid").$$render(
            $$result,
            {
              class: "mx-auto mb-4 text-green-500 w-12 h-12 dark:text-gray-200"
            },
            {},
            {}
          )} <h3 class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400" data-svelte-h="svelte-92xire">Vertragsdokument erstellt &amp; versendet!</h3> ${validate_component(Button, "Button").$$render($$result, {}, {}, {
            default: () => {
              return `OK`;
            }
          })}</div>`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_super_edit();
  $$unsubscribe_trigger_submits();
  $$unsubscribe_employee();
  $$unsubscribe_page();
  $$unsubscribe_employee_extra();
  $$unsubscribe_listView();
  $$unsubscribe_doneModal();
  return $$rendered;
});
export {
  Layout as default
};
//# sourceMappingURL=_layout.svelte.js.map
